import WebStockPage from './WebStockPage';
import webStockPageReducer from './reducer';

export { webStockPageReducer };
export default WebStockPage;
